// SomeComponent.tsx
import React, { useState } from 'react';
import FilePicker from '../components/asset-manager/FilePicker';
import { Asset } from '../components/asset-manager/FileExplorer';

const SomeComponent: React.FC = () => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<Asset[]>([]);

  const handleSelect = (files: Asset[]) => {
    setSelectedFiles(files);
    setIsPickerOpen(false);
  };

  const handlePickerClose = () => {
    setIsPickerOpen(false);
  };

  return (
    <div>
      <button onClick={() => setIsPickerOpen(true)}>Choose File</button>
      {isPickerOpen && (
        <FilePicker
          allowedFileTypes={['image/png', 'image/jpeg']}
          multiSelect={true}
          onSelect={handleSelect}
          onClose={handlePickerClose}
        />
      )}
      {selectedFiles.length > 0 && (
        <div>
          <h3>Selected Files:</h3>
          <ul>
            {selectedFiles.map((file) => (
              <li key={file.id}>{file.filename}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SomeComponent;
